import React from 'react';
import {Button} from '@forecast-it/design-system';
import {useAgentDrawerContext} from '../../forecast-app/shared/contexts/AgentDrawerContext';
import {useIntl} from 'react-intl';

type Props = {
	/**
	 * The gen AI kill switch. The button keeps its place and its sparkle in the nav and is greyed
	 * and inert, rather than disappearing: hiding is what ineligibility does, greying is what the
	 * kill switch does, and the difference is what tells a user AI was switched off rather than
	 * never bought.
	 */
	disabled?: boolean;
};

const AgentTriggerButton = ({disabled = false}: Props): JSX.Element => {
	const {isOpen, openDrawer, closeDrawer} = useAgentDrawerContext();
	const {formatMessage} = useIntl();

	const label = disabled
		? formatMessage({id: 'gen_ai.disabled_label'})
		: isOpen
		? formatMessage({id: 'nova.trigger.close_label'})
		: formatMessage({id: 'nova.trigger.open_label'});

	return (
		<Button
			emphasis="medium"
			rightIcon="sparkle"
			disabled={disabled}
			onPress={isOpen ? closeDrawer : openDrawer}
			aria-label={label}
			data-cy="agent-trigger-button"
		>
			{formatMessage({id: 'nova.trigger.ask_ai'})}
		</Button>
	);
};

export default AgentTriggerButton;
